var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable brace-style, no-var */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var NumberInput = require("../components/number-input.jsx");
var TextInput = require("../components/text-input.jsx");

var ReactionDiagramWidgetEditor = React.createClass({
    displayName: "ReactionDiagramWidgetEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        rotationAngle: React.PropTypes.arrayOf(React.PropTypes.number),
        separators: React.PropTypes.arrayOf(React.PropTypes.object),
        smiles: React.PropTypes.arrayOf(React.PropTypes.string)
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            smiles: ["", ""],
            rotationAngle: [0, 0],
            separators: [{ type: "right", topText: "", bottomText: "" }]
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    updateMolecule: function updateMolecule(idx) {
        return function (newValue) {
            var newSmiles = [].concat(this.props.smiles);
            newSmiles[idx] = newValue;
            this.change({ smiles: newSmiles });
        }.bind(this);
    },

    updateRotation: function updateRotation(idx) {
        return function (newValue) {
            var newRot = [].concat(this.props.rotationAngle);
            newRot[idx] = newValue;
            this.change({ rotationAngle: newRot });
        }.bind(this);
    },

    updateSeparators: function updateSeparators(idx, propName) {
        var _this = this;

        return function (newValue) {
            var newSep = _this.props.separators.map(function (sep) {
                return _extends({}, sep);
            });
            newSep[idx][propName] = newValue;
            _this.change({ separators: newSep });
        };
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    },


    render: function render() {
        // TODO(colin): use styling instead of &nbsp hacks.
        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "LHS SMILES:\xA0",
                    React.createElement(TextInput, {
                        onChange: this.updateMolecule(0),
                        value: this.props.smiles[0]
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "LHS Rotation (deg):\xA0",
                    React.createElement(NumberInput, {
                        onChange: this.updateRotation(0),
                        value: this.props.rotationAngle[0]
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "RHS SMILES:\xA0",
                    React.createElement(TextInput, {
                        onChange: this.updateMolecule(1),
                        value: this.props.smiles[1]
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "RHS Rotation (deg):\xA0",
                    React.createElement(NumberInput, {
                        onChange: this.updateRotation(1),
                        value: this.props.rotationAngle[1]
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Top of arrow text:\xA0",
                    React.createElement(TextInput, {
                        onChange: this.updateSeparators(0, "topText"),
                        value: this.props.separators[0].topText
                    })
                )
            ),
            React.createElement(
                "div",
                null,
                React.createElement(
                    "label",
                    null,
                    "Bottom of arrow text:\xA0",
                    React.createElement(TextInput, {
                        onChange: this.updateSeparators(0, "bottomText"),
                        value: this.props.separators[0].bottomText
                    })
                )
            )
        );
    }
});

module.exports = ReactionDiagramWidgetEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/reaction-diagram-editor.jsx
 ** module id = 143
 ** module chunks = 0 1
 **/